import clsx from 'clsx';
import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { useUser } from '../../app/session';
import { hasPermission } from '../../lib/api';
import { ChannelsAdmin } from './ChannelsAdmin';
import { AiAdmin } from './AiAdmin';
import { HoursAdmin } from './HoursAdmin';
import { QuickRepliesAdmin } from './QuickRepliesAdmin';
import { SettingsAdmin } from './SettingsAdmin';
import { TeamsAdmin } from './TeamsAdmin';
import { TelephonyAdmin } from './TelephonyAdmin';
import { UsersAdmin } from './UsersAdmin';

/** Caminhos absolutos: links relativos dentro de uma rota /admin/* se acumulam no React Router 7. */
export function AdminPage() {
  const user = useUser();
  const tabs = [
    { path: 'usuarios', label: 'Usuários e agentes', allowed: hasPermission(user, 'user:read'), element: <UsersAdmin /> },
    { path: 'telefonia', label: 'Telefonia', allowed: hasPermission(user, 'user:read'), element: <TelephonyAdmin /> },
    { path: 'numeros', label: 'Números (WhatsApp)', allowed: hasPermission(user, 'integration:manage'), element: <ChannelsAdmin /> },
    { path: 'equipes', label: 'Equipes', allowed: hasPermission(user, 'settings:manage'), element: <TeamsAdmin /> },
    { path: 'respostas', label: 'Respostas rápidas', allowed: hasPermission(user, 'quick_reply:manage'), element: <QuickRepliesAdmin /> },
    { path: 'horarios', label: 'Horários', allowed: hasPermission(user, 'settings:manage'), element: <HoursAdmin /> },
    { path: 'ia', label: 'IA', allowed: hasPermission(user, 'settings:manage'), element: <AiAdmin /> },
    { path: 'configuracoes', label: 'Configurações', allowed: hasPermission(user, 'settings:manage'), element: <SettingsAdmin /> },
  ].filter((t) => t.allowed);
  const tab = ({ isActive }: { isActive: boolean }) => clsx('rounded-md px-3 py-1.5 text-sm', isActive ? 'bg-accent/10 font-medium text-accent' : 'text-fg-soft hover:bg-muted');
  return (
    <div className="mx-auto flex h-full max-w-6xl flex-col p-3 md:p-6">
      <div className="mb-4 flex flex-col gap-2 md:flex-row md:flex-wrap md:items-center">
        <h1 className="mr-4 text-lg font-semibold" style={{ fontFamily: 'var(--font-brand)' }}>
          Administração
        </h1>
        {/* Celular: as abas ficam numa faixa que rola de lado. */}
        <div className="flex gap-2 overflow-x-auto whitespace-nowrap max-md:-mx-3 max-md:px-3 max-md:pb-1 md:flex-wrap">
          {tabs.map((t) => (
            <NavLink key={t.path} to={`/admin/${t.path}`} className={tab}>
              {t.label}
            </NavLink>
          ))}
        </div>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto">
        <Routes>
          {tabs.map((t) => (
            <Route key={t.path} path={t.path} element={t.element} />
          ))}
          {tabs[0] && <Route path="*" element={<Navigate to={`/admin/${tabs[0].path}`} replace />} />}
        </Routes>
      </div>
    </div>
  );
}
